import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { getEnvironment } from '~/shared/helpers/getEnvironment'
import { selectIsInContextEnabled } from '~/shared/store/common/selects'

export const useInContextInitialization = () => {
  const { isStageEnvironment } = getEnvironment()
  const isInContextEnabled = useSelector(selectIsInContextEnabled)

  useEffect(() => {
    if (!isStageEnvironment || !isInContextEnabled) return

    const loadInContextScript = async () => {
      const initialScript = document.createElement('script')
      const externalScript = document.createElement('script')

      initialScript.type = 'text/javascript'
      initialScript.text = `
      var _jipt = [];
      _jipt.push(['project', '98ec2e6823117f9fcff2fa853ee12b4f']);
      _jipt.push(['domain', 'gismart']);
    `

      externalScript.type = 'text/javascript'
      externalScript.src = '//cdn.crowdin.com/jipt/jipt.js'
      externalScript.async = true

      document.body.appendChild(initialScript)
      document.body.appendChild(externalScript)
    }

    const timeoutId = setTimeout(loadInContextScript, 500)

    // eslint-disable-next-line consistent-return
    return () => clearTimeout(timeoutId)
  }, [isStageEnvironment, isInContextEnabled])
}
